import { ROUTE_PREV_PATH_PARAM } from 'helpers/constants';
import get from 'lodash/get';
import queryString from 'query-string';

const getQueryStringParam = (history, tPath) => {
  const queryParams = tPath || get(history, 'location.search', '');
  return queryString.parse(queryParams);
};
const getUpdatedUrlQSParam = (pathname, paramObj, replaceAll, history) => {
  const currentPathName = pathname || get(history, 'location.pathname', '');
  const parsed = queryString.parseUrl(currentPathName);
  const newQuery = replaceAll ? paramObj : { ...parsed.query, ...paramObj };
  return queryString.stringifyUrl({ url: parsed.url, query: newQuery });
};
const updateUrlQSParam = (history, paramObj, replaceAll, pathname) => {
  const oldParamObj = getQueryStringParam(history);
  const newParamObj = replaceAll
    ? paramObj
    : {
        ...oldParamObj,
        ...paramObj,
      };
  const currentPathName = pathname || get(history, 'location.pathname', '');
  history.push({
    pathname: currentPathName,
    search: queryString.stringify(newParamObj),
  });
};
const getCurrentPath = match => match?.path || '';
const getFullPath = history => {
  return `${history?.location?.pathname}${history?.location?.search || ''}`;
};
const getPrevPathParam = history => {
  return `${ROUTE_PREV_PATH_PARAM}=${getFullPath(history)}`;
};
const replaceUrlQSParam = objParams => {
  if (!objParams || Object.keys(objParams).length === 0) {
    return;
  }
  const currentParams = new URLSearchParams(window.location.search);
  Object.keys(objParams).forEach(key => {
    currentParams.set(key, objParams[key]);
  });
  const newUrl = `${window.location.pathname}?${currentParams.toString()}`;
  window.history.replaceState({ ...window.history.state }, '', newUrl);
};

export {
  getQueryStringParam,
  updateUrlQSParam,
  getCurrentPath,
  getFullPath,
  getPrevPathParam,
  getUpdatedUrlQSParam,
  replaceUrlQSParam,
};
